import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Attach selected organization to all same-origin API requests via `X-Org` header.
// This ensures older code paths using `fetch()` directly inherit the org context.
;(function attachOrgToFetch() {
  const origFetch = window.fetch.bind(window);
  (window as any).fetch = async (input: RequestInfo, init?: RequestInit) => {
    try {
      const org = localStorage.getItem('organization');
      // Normalize init and headers
      const newInit: RequestInit = init ? { ...init } : {};
      const headers: HeadersInit = newInit.headers ? { ...(newInit.headers as HeadersInit) } : {};

      // Only add header for same-origin or relative '/api' calls
      const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input);
      const isApiCall = url.startsWith('/') || url.includes(window.location.origin);
      if (org && isApiCall) {
        headers['X-Org'] = org;
      }

      newInit.headers = headers;
      return await origFetch(input, newInit);
    } catch (e) {
      return origFetch(input, init);
    }
  };
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

